import React from 'react';
import classnames from 'classnames';
import { Dropdown } from 'tea-component';
import Result from './components/Result';
import Selector from './components/Selector';
import useResult from './hooks/useResult';
import { TYPES } from './_config/constant';

import type { IBaseProps, IDateType, IDateValue } from '@/pages/intelligence/types/common';
import type { IPickerValue, IDateTypeOption } from './types';

import './index.scss';

interface IRangeDayMonthPickerProps extends IBaseProps {
  disabled?: boolean;
  types?: IDateType[];
  value?: IPickerValue;
  defaultValue?: IPickerValue;
  onConfirm?: (type: IDateType, value: IDateValue) => void;
  onCancel?: () => void;
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
  boxClassName?: string;
  boxStyle?: React.CSSProperties;
}

export default function RangeDayMonthPicker(props: IRangeDayMonthPickerProps) {
  const {
    disabled = false,
    types,
    value,
    defaultValue,
    onConfirm,
    onCancel,
    className,
    style,
    overlayClassName,
    overlayStyle,
    boxClassName,
    boxStyle,
  } = props;

  const typesOptions: IDateTypeOption[] = (() => {
    if (!Array.isArray(types)) return TYPES;
    return TYPES?.filter((item) => types?.includes(item?.value));
  })();

  const { result, handleConfirm, handleCancel } = useResult({
    types: typesOptions,
    value,
    defaultValue,
    onConfirm,
    onCancel,
  });

  return (
    <Dropdown
      style={style}
      className={classnames('range-day-month-selector__header-wrapper', className)}
      disabled={disabled}
      clickClose={false}
      button={<Result types={typesOptions} value={result} />}
      boxStyle={{
        ...boxStyle,
        padding: 0,
      }}
      boxClassName={boxClassName}
      overlayStyle={overlayStyle}
      overlayClassName={overlayClassName}
      size='m'
    >
      {(close) => (
        <Selector
          types={typesOptions}
          defaultValue={result}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          onClose={close}
        />
      )}
    </Dropdown>
  );
}
